import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamIdError: {
		id: 'eoc-schedule.controllers.use-team-id.team-id-error',
		defaultMessage: 'Schedules cannot be used without a team, please check the path.',
		description:
			'This message indicates schedule page is being rendered where team id does not exist, so schedule page fails to load.',
	},
});
